// extracted by mini-css-extract-plugin
export default {"wrapper":"Guide_wrapper__lGs9P","wrapper--active":"Guide_wrapper--active__QpLXY","button":"Guide_button__AvxfQ","icon":"Guide_icon__N5oCD"};